import React from 'react';

const AppDownloadBanner: React.FC = () => {
  return (
    <div 
      className="app-download-banner position-relative overflow-hidden"
      style={{
        background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
        padding: '20px 0',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
      }}>
      
      {/* Animated Background Effect */}
      <div className="position-absolute w-100 h-100" style={{ opacity: 0.1 }}>
        <div className="position-absolute rounded-circle" 
          style={{ 
            width: '150px', 
            height: '150px', 
            background: 'white',
            top: '-50px',
            right: '10%',
            animation: 'float 4s ease-in-out infinite'
          }}></div>
        <div className="position-absolute rounded-circle" 
          style={{ 
            width: '100px', 
            height: '100px', 
            background: 'white',
            bottom: '-30px',
            left: '15%',
            animation: 'float 5s ease-in-out infinite reverse'
          }}></div>
      </div>

      <div className="container position-relative">
        <div className="row align-items-center justify-content-center">
          <div className="col-auto text-center text-lg-start mb-2 mb-lg-0">
            <div className="d-flex align-items-center justify-content-center justify-content-lg-start flex-wrap gap-2">
              <div className="d-flex align-items-center">
                <div 
                  className="d-flex align-items-center justify-content-center rounded-circle me-3"
                  style={{
                    width: '45px',
                    height: '45px',
                    background: 'rgba(255, 255, 255, 0.2)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.3)'
                  }}>
                  <i className="fas fa-mobile-alt fa-lg text-white"></i>
                </div>
                <div className="text-white">
                  <div className="fw-bold fs-5 mb-0">Get the WiZiAI App</div>
                  <small style={{ opacity: 0.9 }}>Study anytime, anywhere</small>
                </div>
              </div>
              
              <div className="d-none d-md-block mx-3" 
                style={{ 
                  height: '40px', 
                  width: '1px', 
                  background: 'rgba(255, 255, 255, 0.3)' 
                }}></div>

              <a 
                href="https://play.google.com/store/apps/details?id=com.wiziai.student&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-light px-4 py-2 rounded-pill d-flex align-items-center shadow"
                style={{
                  transition: 'all 0.3s ease',
                  fontWeight: '600'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                }}>
                <i className="fab fa-google-play me-2" style={{ fontSize: '1.2rem' }}></i>
                <span>Download on Google Play</span>
              </a>

              <div className="d-flex align-items-center text-white ms-2">
                <div className="d-flex">
                  <i className="fas fa-star" style={{ fontSize: '0.9rem', opacity: 0.9 }}></i>
                  <i className="fas fa-star" style={{ fontSize: '0.9rem', opacity: 0.9 }}></i>
                  <i className="fas fa-star" style={{ fontSize: '0.9rem', opacity: 0.9 }}></i>
                  <i className="fas fa-star" style={{ fontSize: '0.9rem', opacity: 0.9 }}></i>
                  <i className="fas fa-star" style={{ fontSize: '0.9rem', opacity: 0.9 }}></i>
                </div>
                <small className="ms-2 fw-semibold" style={{ opacity: 0.9 }}>4.8+</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadBanner;
